<template>
    <v-app>
        <driverBar back="driverDay"></driverBar>
        <v-main>
            <v-container>
                <div class="title mb-1">แจ้งสถานีชาร์จ/ปั๊มแก๊ส</div>
                <div class="body-2 grey--text text--darken-1 mb-4">
                    ยืนอยู่ที่สถานีแล้วกดใช้ตำแหน่งปัจจุบัน
                </div>

                <v-card><v-card-text>
                    <v-radio-group v-model="kind" row class="mt-0">
                        <v-radio label="สถานีชาร์จ EV" value="ev" color="orange accent-4"></v-radio>
                        <v-radio label="ปั๊มแก๊ส NGV" value="gas" color="orange accent-4"></v-radio>
                    </v-radio-group>

                    <v-text-field v-model="name" label="ชื่อสถานี" dense color="orange accent-3"></v-text-field>
                    <v-text-field v-model="brand" label="แบรนด์ (ถ้ามี)" dense color="orange accent-3"></v-text-field>

                    <v-btn block outlined color="primary" class="mb-3" :loading="locating" :disabled="locating" @click="locate">
                        <v-icon left>mdi-crosshairs-gps</v-icon>ใช้ตำแหน่งปัจจุบัน
                    </v-btn>

                    <v-alert v-if="lat != null" dense text type="success">
                        {{ lat.toFixed(6) }}, {{ lng.toFixed(6) }}
                        <span v-if="accuracy != null"> (± {{ Math.round(accuracy) }} ม.)</span>
                    </v-alert>

                    <v-textarea v-model="note" label="หมายเหตุ" rows="2" dense color="orange accent-3"></v-textarea>

                    <v-btn block large color="orange accent-4" dark :loading="busy" :disabled="busy" @click="submit">
                        ส่งรายงาน
                    </v-btn>
                </v-card-text></v-card>

                <v-snackbar v-model="showMsg" :color="msgColor" :timeout="5000">
                    <span class="pre-line-msg">{{ msg }}</span>
                </v-snackbar>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import driverBar from '@/components/driver/driverBar'
import driverService from '@/components/driverService'
export default {
    components: { driverBar },
    data () {
        return {
            kind: 'ev', name: '', brand: '', note: '',
            lat: null, lng: null, accuracy: null,
            locating: false, busy: false,
            msg: '', msgColor: 'red', showMsg: false
        }
    },
    methods: {
        say (text, color) { this.msg = text; this.msgColor = color || 'red'; this.showMsg = true },
        locate () {
            if (this.locating) return
            if (!navigator.geolocation) { this.say('อุปกรณ์นี้ไม่รองรับการหาตำแหน่ง'); return }
            this.locating = true
            navigator.geolocation.getCurrentPosition(
                pos => {
                    this.lat = pos.coords.latitude
                    this.lng = pos.coords.longitude
                    this.accuracy = pos.coords.accuracy
                    this.locating = false
                },
                () => { this.locating = false; this.say('หาตำแหน่งไม่ได้ ตรวจสอบการอนุญาตตำแหน่งของเบราว์เซอร์') },
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
            )
        },
        async submit () {
            if (this.busy) return
            this.busy = true
            try {
                await driverService.submitStationReport({
                    kind: this.kind, name: this.name, brand: this.brand,
                    lat: this.lat, lng: this.lng, accuracy: this.accuracy, note: this.note
                })
                this.name = ''; this.brand = ''; this.note = ''
                this.lat = null; this.lng = null; this.accuracy = null
                this.say('ส่งรายงานแล้ว ขอบคุณครับ', 'green')
            } catch (e) {
                if (e && e.code === driverService.NOT_SIGNED_IN) {
                    // Same as stop.vue/pin.vue: nobody to report for. Back to
                    // the keypad rather than a message the driver cannot act on.
                    this.$router.push({ name: 'driverPin' }).catch(() => {})
                } else {
                    // validateReport's messages are already Thai and already say
                    // what to fix, so only those are shown as they are --
                    // matched by e.code (see driverService.js's comment near
                    // NOT_SIGNED_IN), never the message text, so rewording a
                    // validation message can't silently stop it from being
                    // recognised here.
                    this.say((e && e.code === driverService.INVALID_REPORT && e.message) || 'ส่งรายงานไม่สำเร็จ')
                }
            }
            this.busy = false
        }
    }
}
</script>
<style scoped>
/* submitStationReport joins multiple Thai validation messages with '\n' --
   without this, HTML collapses them into one run-on sentence in the snackbar. */
.pre-line-msg {
    white-space: pre-line;
}
</style>
